//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import parse from 'date-fns/parse'
//import format from 'date-fns/format'

export default {
  props: {
    block: {
      type: Object,
      default: null
    }
  },
  components: {

  },
  computed: {
 
  },
  watch: {

  },
  filters: {

  },
  data() {
    return { 
      
      loading: true,
      ui: {
        currentSlide: 0
      },
      
    }
  },
  mounted() {

console.log('THE BLOCK', this.block)
 

  },
  methods: {

    slideChanged: function ({currentSlide}) {
      console.log('CURRENT', currentSlide)
      this.ui.currentSlide = currentSlide.index
    },
    getStops: function(days) {

      console.log('DAYS', days)

      return days.reduce( (prev, cur) => {
        return prev + cur.stops.length 
      }, 0 )

    }

    
  }
}




// WEBPACK FOOTER //
// ./scripts/components/KitBlocks/KitTours.vue